import React, { useEffect, useState } from 'react'
import { FaAngleLeft } from "react-icons/fa6";
import { SlHome } from "react-icons/sl";
import { useLocation, useNavigate } from 'react-router';
import { getWallet } from '../Services/Operations/ProductAPI';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

const Wallet = () => {
    const [wallet, setWallet] = useState({});
    const navigation = useNavigate();
    const token = useSelector((state) => state.user.token);
    const user_id = useSelector((state) => state.user.userId);

    useEffect(() => {
        const fetchProfile = async () => {
            try {
                const formData = new FormData();
                formData.append("token", token);
                formData.append("user_id", user_id);

                for (let pair of formData.entries()) {
                    console.log(`${pair[0]}: ${pair[1]}`);
                }

                const response = await getWallet(formData);
                if (response) {
                    console.log("Wallet Data:", response);
                    setWallet(response);
                }

            } catch (error) {
                console.error("Error fetching profile or pages:", error);
            }
        };

        fetchProfile();
    }, [token]);


    return (
        <div>
            <div
                style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    width: "100%",
                    maxWidth: "770px",
                    margin: "auto"
                }}
            >
                <div style={{ display: "flex", justifyContent: "center", alignItems: "center", }}>
                    <FaAngleLeft onClick={() => navigation(-1)} />
                    <p style={{ marginLeft: "23px" }}>My Wallet</p>
                </div>
                <div style={{ display: "flex", gap: "20px", marginRight: "13px" }}>
                    <Link to="/"><SlHome /></Link>
                </div>
            </div>
            <div style={{
                marginTop: "20px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: "100%"
            }}>
                <button style={{
                    width: "90%",
                    padding: "8px 0px",
                    fontSize: "16px",
                    backgroundColor: "white",
                }}>Zotpot Wallet ₹{wallet.balance}</button>
            </div>
        </div>
    )
}

export default Wallet
